// Referral extension (admin side): the embeddable buy button.
// The tab is the old catalog editor's ReferralTab, reused as it is. It edits
// nothing — it only needs the product id and the languages, which the shared
// catalog editor (../shared/catalog-editor.jsx) already has.
//
// Referral is not in STORE_PRODUCT_MODEL.md: it owns no fields, so it has no
// server half; it is here so the catalog editor has no tab left behind.
import { ShareIcon } from "@heroicons/react/24/outline"
import ReferralTab from "./ReferralTab"
import { CatalogEditorProvider, catalogSection, catalogVisible, useCatalogVisibilityContext } from "../shared/catalog-editor"

export const StoreProductExtension = {
  id: "referral",
  label: "Referral",
  description: "The external purchase button: a live preview and the embed code",
  section: {
    component: catalogSection(ReferralTab),
    label: "Referral",
    icon: ShareIcon,
    order: 1400,
    visible: catalogVisible("referral"),
  },
  provider: CatalogEditorProvider,
  visibilityContext: useCatalogVisibilityContext,
}
